import React, { useState } from "react";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";

import { Rules } from "@dashboard/settings/rules/Rules";
import { getRoute } from "@services/axios";
import { updtaSettingWithValidation } from "../Action";
import { useTranslation } from "react-i18next";

const Billing = (props) => {
   const { t } = useTranslation();
  const InputSection = props.InputSection;
  const rules = new Rules(props.t);
  const [loading, setLoading] = useState(false);

  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      cardholder_name: "",
      card_number: "",
      expiration_date: "",
      cvv: "",
      card_type: "",
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const extraParam = {
      route: getRoute("PROFILE_CARTE_CREDIT"),
      t: props.t,
      title: t("enter_your_code_validation"),
      setLoading: setLoading,
    };
    await updtaSettingWithValidation(data, extraParam);
  };

  return (
    <>
      <div className="fs-5 fw-medium text-dark">{props.t("billing_title")}</div>
      <p className="fw-light">{props.t("billing_subtitle")}</p>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form as="div" className="my-3"></Form>

        <InputSection
          title={props.t("card_infoTitle")}
          description={props.t("card_infoDescription")}
          input={
            <IController
              elment={`cardholder_name`}
              item={rules.fullName()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />

        <hr className="border-secondary my-4" />

        <InputSection
          title={props.t("card_number")}
          description={props.t("hint_cardNumber")}
          input={
            <IController
              elment={`card_number`}
              item={rules.card()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />

        <hr className="border-secondary my-4" />

        <InputSection
          title={props.t("card_expirationTitle")}
          description={props.t("card_expirationDescription")}
          input={
            <IController
              elment={`expiration_date`}
              item={rules.expirationDate()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />

        <hr className="border-secondary my-4" />

        <InputSection
          title={props.t("card_cvvTitle")}
          description={props.t("card_cvvDescription")}
          input={
            <IController
              elment={`cvv`}
              item={rules.cvv()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />
        <hr className="border-secondary my-4" />

        <InputSection
          title={props.t("card_type")}
          description={props.t("VISA, MASTERCARD,AMERICANEXPRESS, or DISCOVER")}
          input={
            <IController
              elment={`card_type`}
              item={rules.cardType()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />
        <hr className="border-secondary my-4" />

        <InputSection
          title=""
          description=""
          input={
            <Form
              as="button"
              type="submit"
              className="btn-blue p-4 rounded-3 fw-bold w-100"
            >
              {loading ? (
                <Form
                  as="span"
                  className="spinner-border spinner-border-sm m-1 "
                ></Form>
              ) : (
                props.t("reset")
              )}
            </Form>
          }
        />
      </Form>
    </>
  );
};

export default Billing;
